import { render, staticRenderFns } from "./MarketPositionIndicator.vue?vue&type=template&id=08528b12&scoped=true"
import script from "./MarketPositionIndicator.vue?vue&type=script&lang=js"
export * from "./MarketPositionIndicator.vue?vue&type=script&lang=js"
import style0 from "./MarketPositionIndicator.vue?vue&type=style&index=0&id=08528b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08528b12",
  null
  
)

export default component.exports